<template>
  <ItemDialog ref="refDialog" image-type="alert">
    <template #content-area>
      <h2>{{ errorTitle }}</h2>
      <p>{{ errorSubTitle }}</p>
    </template>
    <template #button-area>
      <ItemButton label="OK" action-type="btn-primary" @clicked="clicked" />
    </template>
  </ItemDialog>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";

import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "DialogError",
  props: {
    errorTitle: {
      type: String,
      require: true,
    },
    errorSubTitle: {
      type: String,
      require: false,
    },
    action: {
      type: Function,
      default: null,
      require: true,
    },
  },
  setup(props) {
    const refDialog = ref(null);

    const openDialog = () => {
      refDialog.value.open();
    };

    const closeDialog = () => {
      refDialog.value.close();
    };

    const clicked = () => {
      closeDialog();
      if (props.action) {
        props.action();
      }
    };

    return {
      refDialog,
      openDialog,
      closeDialog,
      clicked,
    };
  },
};
</script>
